import styled from 'styled-components'

export const TooltipContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 350px;
  position: relative;
  z-index: 900;
  animation: fadeIn 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 400px) {
    width: 300px;
  }

  @media (max-width: 768px) {
    z-index: 997;
  }
`

export const TooltipArrow = styled.div`
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 16px;
  height: 16px;
  background: #ffffff;
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
`

export const TooltipHeader = styled.div`
  padding: 12px 12px 10px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 12px;
`

export const RadarChartContainer = styled.div`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
`

export const HeaderContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const AddressContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 2px;
`

export const MainAddress = styled.div<{ $noAddress?: boolean }>`
  font-size: 13px;
  font-weight: 600;
  color: ${({ $noAddress }) => ($noAddress ? '#999999' : '#1a1a1a')};
  line-height: 1.3;
  flex: 1;
  ${({ $noAddress }) =>
    $noAddress &&
    `
    font-weight: 400;
    font-style: italic;
  `}
`

export const MoreAddresses = styled.div`
  font-size: 11px;
  color: #6b6b6b;
  background: #f5f5f5;
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
`

export const PlotNumber = styled.div`
  font-size: 12px;
  color: #6b6b6b;
  display: flex;
  align-items: center;
  gap: 4px;
`

export const TooltipContent = styled.div`
  padding: 12px;
`

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
`

export const MetricItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`

export const MetricLabel = styled.div`
  font-size: 10px;
  color: #999999;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.2;
`

export const MetricValue = styled.div`
  font-size: 13px;
  color: #1a1a1a;
  font-weight: 600;
  line-height: 1.2;
`

export const ZoningSection = styled.div`
  margin-bottom: 0;
`

export const SectionLabel = styled.div`
  font-size: 10px;
  color: #999999;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
  line-height: 1.2;
`

export const ZoningInfo = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`

export const ZoningName = styled.div`
  font-size: 12px;
  color: #1a1a1a;
  font-weight: 500;
  flex: 1;
  line-height: 1.3;
`

export const MoreZonings = styled.div`
  font-size: 11px;
  color: #6b6b6b;
  background: #f5f5f5;
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
`

export const ZonePercentage = styled.span`
  font-size: 11px;
  color: #6b6b6b;
  background: #f0f7ff;
  padding: 1px 6px;
  border-radius: 4px;
  margin-left: 6px;
  font-weight: 500;
`

export const PlotIcon = styled.svg`
  width: 12px;
  height: 12px;
  stroke: currentColor;
  stroke-width: 2px;
  fill: none;
`
